import { mapGetters } from 'vuex'
import CciScrubberItem from './item/CciScrubberItem.vue'
import Swiper from 'swiper/bundle'

export default {
  data () {
    return {
      scrubber: null
    }
  },
  mounted () {
    this.applySettings(this.settings)
    let that = this
    let initialSlidePageNumber = this.$store.state.currentPage.firstPage.interstitialInfo === null ? (that.$store.state.currentPage.firstPage.pageNumber) : that.$store.state.currentPage.firstPage.interstitialInfo.interstitialAfterPageNo.toString()
    initialSlidePageNumber = this.parseFirstPageIndexInScrubber(initialSlidePageNumber)
    this.$nextTick(function () {
      this.scrubber = new Swiper('.scrubber-swiper-container', {
        init: false,
        preloadImages: false,
        lazy: true,
        initialSlide: initialSlidePageNumber,
        centeredSlides: true,
        setWrapperSize: true,
        direction: 'horizontal',
        slidesPerView: 'auto',
        watchSlidesVisibility: true,
        freeMode: false,
        observer: true,
        wrapperClass: 'scrubber-swiper-wrapper',
        slideClass: 'scrubber-swiper-slide',
        grapCursor: false,
        watchOverflow: true,
        navigation: {
          nextEl: '.scrubber-next',
          prevEl: '.scrubber-prev'
        },
        on: {
          init: function () {
            let activeSlide = that.scrubber.slides[initialSlidePageNumber]
            activeSlide.getElementsByClassName('scrubber-thumbnail')[0].classList.add('scrubber-active-thumbnail')
            activeSlide.getElementsByClassName('scrubber-page-number scrubber-font')[0].style.marginTop = '0px'
          },
          resize: function () {
            that.scrubber.update()
          },
          lazyImageReady: function () {
            // Swiper doesn't update the positioning of the slides once a lazy image has actually loaded,
            // which causes them to get incorrect offsets. This is only a problem when the slides vary in size,
            // which is the case here since we load images of varying widths. Fix it by using the internal
            // function updateSlides() as well as running slideTo() to the current slide after every lazy
            // image has finished loading.
            // that.scrubber.updateSlides()
            // that.scrubber.slideTo(this.activeIndex, 0, false)
          }
        }
      })
      this.scrubber.init()
    })
  },
  computed: {
    validPages: function () {
      var validPages = []
      for (var i = 0; i < this.pages.length; i++) {
        var page = this.pages[i]
        if (page.firstPage.interstitialInfo === null && !page.firstPage.isInterstitial) {
          validPages.push(page)
        }
      }
      return validPages
    },
    ...mapGetters({
      showScrubber: 'getShowScrubber',
      pages: 'getPages',
      settings: 'getSettings'
    })
  },
  watch: {
    settings: function (newValue) {
      this.applySettings(newValue)
    }
  },
  methods: {
    applySettings (settings) {
      if (settings !== undefined) {
        var scrubber = document.getElementsByClassName('scrubber')[0]
        scrubber.style.backgroundColor = settings.scrubberBackgroundColor

        // var url = settings.scrubberNextArrowIconURL
        // if (url !== '') {
        //   var icon = document.getElementsByClassName('scrubber-next-a')[0]
        //   icon.style.background = 'url(' + url + ')'
        //   icon.style.backgroundSize = 'cover'
        // }
        //
        // url = settings.scrubberPrevArrowIconURL
        // if (url !== '') {
        //   var icon1 = document.getElementsByClassName('scrubber-prev-a')[0]
        //   icon1.style.background = 'url(' + url + ')'
        //   icon1.style.backgroundSize = 'cover'
        // }
      }
    },
    parseFirstPageIndexInScrubber (pageNo) {
      for (var i = 0; i < this.pages.length; i++) {
        let page = this.pages[i]
        if (page.firstPage.pageNumber === pageNo) {
          return i
        }
      }
    }
  },
  components: {
    CciScrubberItem
  },
  beforeDestroy () {
    if (this.scrubber !== null) {
      this.scrubber.destroy()
      this.scrubber = null
    }
  }
}
